__turbopack_context__.v({
  "actions": "GraftabilityWarningTabContent-module-scss-module__47JW6q__actions",
  "issueList": "GraftabilityWarningTabContent-module-scss-module__47JW6q__issueList",
  "issues": "GraftabilityWarningTabContent-module-scss-module__47JW6q__issues",
  "issuesTitle": "GraftabilityWarningTabContent-module-scss-module__47JW6q__issuesTitle",
  "root": "GraftabilityWarningTabContent-module-scss-module__47JW6q__root",
});
